import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { horizontalScale, mobileMediaQuery } from 'utils/helpers';
import { ReactComponent as CheckmarkSvg } from 'assets/svg/checkbox-icon-tick.svg';

const Checkbox = ({
  type,
  checked = false,
  toggleCheckbox,
  ...props
}: PropsWithChildren<{
  type?: string;
  checked?: boolean;
  toggleCheckbox: (type?: string) => void;
}>) => {
  return (
    <CheckboxLabel>
      <HiddenCheckbox
        type="checkbox"
        checked={checked}
        onChange={() => toggleCheckbox(type)}
      />
      {checked ? (
        <StyledCheckboxChecked>
          <CheckmarkSvg />
        </StyledCheckboxChecked>
      ) : (
        <StyledCheckboxUnchecked />
      )}
      {props.children}
    </CheckboxLabel>
  );
};
export default Checkbox;

const CheckboxLabel = styled.label`
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: ${horizontalScale(20)};
  cursor: pointer;
  user-select: none;

  ${mobileMediaQuery(
    (css, mobileScale) => css`
      gap: ${mobileScale(10)};
    `
  )}
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

const StyledCheckboxUnchecked = styled.div`
  flex-shrink: 0;
  display: inline-block;
  width: ${horizontalScale(27)};
  height: ${horizontalScale(27)};
  border: 1px solid #5d5b60;
  background-color: #ffffff;
  position: relative;

  ${mobileMediaQuery(
    (css, mobileScale) => css`
      width: ${mobileScale(15)};
      height: ${mobileScale(15)};
    `
  )}
`;

const StyledCheckboxChecked = styled.div`
  flex-shrink: 0;
  display: inline-block;
  width: ${horizontalScale(27)};
  height: ${horizontalScale(27)};
  border: 1px solid #5d5b60;
  position: relative;
  background-color: #5d5b60;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mobileMediaQuery(
    (css, mobileScale) => css`
      width: ${mobileScale(15)};
      height: ${mobileScale(15)};
      box-shadow: 0px 0px 0px ${mobileScale(2)} #5d5b60 inset;

      svg {
        width: ${mobileScale(9)};
        height: ${mobileScale(9)};
      }
    `
  )}
`;
